// extracted by mini-css-extract-plugin
module.exports = {"cmp":"footer_cmp__31hkK","footnote":"footer_footnote__2xtxn","copy":"footer_copy__2uS59","social":"footer_social__jC9bq"};